import { ChangeDetectorRef, Directive, ElementRef, EventEmitter, HostListener, Input, Renderer2 } from "@angular/core";
import { IonContent } from "@ionic/angular";

export interface ArrowKeysOptions{

    /**
     * Ob aktiv ist
     */
    active?: boolean

    /**
     * Content der gescroll werden soll pfeil gedrückt wird
     */
    ionContent?: IonContent

    /**
     * Index an dem sich selectiertes Item befindet
     */
    selectedItem: number

    /**
     * Event was gefeuert wird wenn Enter gedrückt wird
     */
    enterPressed: (index: number) => void

    /**
     * Updatet die DOM Elemente
     * @returns 
     */
    updateDOM?: () => void

    /**
     * Event was gefeuert wird wenn Maus über item ist 
     * number -> Index des Items in Liste
     */
    mouseOverItem: EventEmitter<number>

    /**
     * Event was gefeuert wird wenn sich Maus bewegt
     */
    mouseMove: EventEmitter<boolean>

    /**
     * nimmt selected classe von Element
     */
    clearSelectedItem?: EventEmitter<boolean>

}

@Directive({
    selector: "[ArrowKeyUseable]"
})
export class ArrowKeyUseable{

    @Input() arrowKeysOptions: ArrowKeysOptions

    /**
     * ION Items als native DOM Elemente
     */
    private elements: any[] = []

    /**
     * Sagt ob Maus zuletzt bewegt wurde oder mit Keys navigiert wurde
     */
    private isMove: boolean = true

    /**
     * Setzt ein ausgewähltes Items eins nach unten
     */
    @HostListener('window:keydown.ArrowDown') async keyDown(){
        if(this.arrowKeysOptions.active == false) return
        this.isMove = false
        if(this.arrowKeysOptions.selectedItem < this.elements.length - 1){
            this.removeOldSelectedItemDOM()
            this.arrowKeysOptions.selectedItem++
            if(this.arrowKeysOptions.ionContent && this.arrowKeysOptions.selectedItem > 1 ){
                await this.arrowKeysOptions.ionContent.scrollByPoint(0, this.elements[this.arrowKeysOptions.selectedItem].offsetHeight, 1)
            }
            this.selectItemInDOM()
        }
    }

    /**
     * Setzt ein ausgewähltes Items eins nach unten
     */
    @HostListener('window:keydown.ArrowUp') async onKeyup(){
        if(this.arrowKeysOptions.active == false) return
        this.isMove = false
        if(this.arrowKeysOptions.selectedItem > 0){
            if(this.arrowKeysOptions.ionContent){
                await this.arrowKeysOptions.ionContent.scrollByPoint(0, -this.elements[this.arrowKeysOptions.selectedItem].offsetHeight, 1)
            }
            this.removeOldSelectedItemDOM()
            this.arrowKeysOptions.selectedItem--
            this.selectItemInDOM()
        }
    }

    /**
     * Feuter in einstellungsobject die Enter-Funktion mit dem index des augewählten Items
     */
    @HostListener('window:keydown.Enter') enterClicked(){
        if(this.arrowKeysOptions.active == false) return
        this.arrowKeysOptions.enterPressed(this.arrowKeysOptions.selectedItem)
    }

    constructor( el: ElementRef, public changeDetector: ChangeDetectorRef){
        this.elements = el.nativeElement.getElementsByTagName("ion-item")
    }

    /**
     * Subscribtion an die Mouse-Events
     */
    ngOnInit(){
        this.arrowKeysOptions.mouseOverItem.subscribe((index: number)=>{
            if(index == null || index == this.arrowKeysOptions.selectedItem || !this.isMove) return 
            this.isMove = false
            this.removeOldSelectedItemDOM()
            this.arrowKeysOptions.selectedItem = index
            this.selectItemInDOM()
        })

        this.arrowKeysOptions.mouseMove.subscribe((val: boolean)=>{
            if(val == null) return
            this.isMove = val
        })

        if(this.arrowKeysOptions?.clearSelectedItem) this.arrowKeysOptions.clearSelectedItem.subscribe(()=>this.removeOldSelectedItemDOM())

        this.arrowKeysOptions.updateDOM = () => this.selectItemInDOM()
    }

    /**
     * Setzt CSS-Klasse für das ausgewählte Item
     */
    private selectItemInDOM(){
        this.elements[this.arrowKeysOptions.selectedItem]?.classList?.add("selected")
    }

    /**
     * entfernt CSS-Klasse aus altem ausgewählten Item
     */
    private removeOldSelectedItemDOM(){
        let classList: any = this.elements[this.arrowKeysOptions.selectedItem]?.classList
        if(classList?.contains("selected")) classList.remove("selected")
    }
}